import store     from '../../../store';
import BaseStore from "../../../App/Data/Store/BaseStore";
import Swatches  from './Swatches';

export default class ActivePalette extends BaseStore {

    module = ['Palettes', 'ActivePalette'];

    activate(paletteId, swatchIndex) {
        localStorage.lastPaletteId = paletteId;
        this.commit('setPalette', paletteId);
        this.commit('setActiveSwatch', swatchIndex);
    }

    addSwatch() {
        let paletteId = this.state('id'),
            swatch = this.getActiveSwatch(),
            swatchCount = this.getters('swatchCount');
        new Swatches().push(swatch, paletteId);
        this.commit('setActiveSwatch', swatchCount - 1);
    }

    getActiveSwatch() {
        return this.getters('activeSwatch');
    }

    getPalette() {
        return this.getters('palette');
    }

    getActiveSwatchIndex() {
        return this.state('activeSwatchIndex');
    }

    getSwatchCount() {
        return this.getters('swatchCount');
    }

    updateNotes(notes) {
        store.commit('Palettes/updateNotes', { paletteId: this.state('id'), notes });
    }
}
